import { Box, Flex, Link } from '@chakra-ui/react';
import React from 'react';
import { useFormContext } from 'react-hook-form';

import type { FormFields } from '../types';

import config from 'configs/app';
import { useI18n } from 'lib/i18n/context';

import ContractVerificationFormCodeSnippet from '../ContractVerificationFormCodeSnippet';
import ContractVerificationFormRow from '../ContractVerificationFormRow';
import ContractVerificationMethod from '../ContractVerificationMethod';
import { CONTRACT_VERIFICATION_METHOD_TITLE_KEYS, CONTRACT_VERIFICATION_TUTORIAL_KEYS } from '../i18n';

const ContractVerificationSolidityFoundry = () => {
  const { t } = useI18n();
  const { watch } = useFormContext<FormFields>();
  const address = watch('address');

  const codeSnippet = `forge verify-contract \\
  --rpc-url ${ config.chain.rpcUrl || `${ config.api.endpoint }/api/eth-rpc` } \\
  --verifier blockscout \\
  --verifier-url '${ config.api.endpoint }/api/' \\
  ${ address || '<address>' } \\
  [contractFile]:[contractName]`;

  return (
    <ContractVerificationMethod title={ t(CONTRACT_VERIFICATION_METHOD_TITLE_KEYS['solidity-foundry']) }>
      <ContractVerificationFormRow>
        <Flex flexDir="column">
          <ContractVerificationFormCodeSnippet code={ codeSnippet }/>
        </Flex>
        <Box whiteSpace="pre-wrap">
          <span>{ t(CONTRACT_VERIFICATION_TUTORIAL_KEYS.foundryPart1) } </span>
          <Link href="https://docs.blockscout.com/for-users/verifying-a-smart-contract/foundry-verification" target="_blank">
            { t(CONTRACT_VERIFICATION_TUTORIAL_KEYS.foundryLink) }
          </Link>
        </Box>
      </ContractVerificationFormRow>
    </ContractVerificationMethod>
  );
};

export default React.memo(ContractVerificationSolidityFoundry);
